'use client'

import React from 'react'
import Image from 'next/image'
import { useRouter } from 'next/navigation'
import { useSelector } from 'react-redux'
import { RootState } from 'features/store'

type ProfileCompletedModalProps = {
    open: boolean
    onClose: () => void
}

const ProfileCompletedModal = ({ open, onClose }: ProfileCompletedModalProps) => {
    const router = useRouter()
    const user = useSelector((state: RootState) => state.culineerAuth.user)

    if (!open) return null

    const handleExploreDashboard = () => {
        onClose()
        const isProducer = user?.user_type?.toLowerCase() === 'producer'
        router.push(isProducer ? '/dashboard' : '/discover')
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black/50" onClick={onClose} />
            <div className="relative z-10 mx-4 w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl">
                {/* X close button */}
                <button
                    onClick={onClose}
                    className="absolute right-4 top-4 text-gray-400 hover:text-gray-600"
                >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                    </svg>
                </button>

                {/* Icon + Title row */}
                <div className="mb-3 flex items-center gap-3">
                    <Image
                        src="/assets/icons/profile-complete-badge.png"
                        alt="Profile complete"
                        width={56}
                        height={56}
                        className="flex-shrink-0"
                    />
                    <h2 className="text-lg font-bold text-gray-900">
                        Profile Completed Successfully!
                    </h2>
                </div>

                {/* Body */}
                <p className="mb-6 text-sm leading-relaxed text-gray-500">
                    Your account is now fully set up. You're ready to explore Culineer with a personalized experience.
                </p>

                {/* Buttons */}
                <div className="flex items-center justify-between gap-3">
                    <button
                        onClick={onClose}
                        className="text-sm font-medium text-gray-500 hover:text-gray-700"
                    >
                        Close
                    </button>
                    <button
                        onClick={handleExploreDashboard}
                        className="rounded-full bg-[#85C349] px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-[#75B339]"
                    >
                        Explore Dashboard
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ProfileCompletedModal
